
export class EntitiesRenderer {

    // the identifier for this kind of entity
    key:string = null;

    // entities
    items:any[] = [];

    constructor ( key:string = null ) {

    }

    incoming ( items:any[] = [] ) {
        this.items = items;
    }

    plotAll() {

    }

    unplotAll() {

    }

    plot ( item:any = null ) {

    }

    unplot ( item:any = null ) {

    }

}